.account {
  display: flex;
  background-color: var(--background-default);
}

.accountContent {
  flex: 1 1 auto;
  margin-left: 16px;
}

.accountName {
  font-weight: 500;
}

.accountAvatar {
  width: 48px;
  height: 48px;
}

.skeletonName {
  margin-bottom: 8px;
}
